import { CrmObject, type CrmSearchHit } from "../../generated/graphql";
import type { DialRecord } from "./phoneEngine";

// The only records a call can be linked to.
const CALL_RECORD_OBJECTS = new Set<CrmObject>([CrmObject.Account, CrmObject.Contact, CrmObject.Lead, CrmObject.Case]);

/** The record a call can be linked to, or undefined when the record is none or of another kind. */
export const callRecord = (record: DialRecord | null): DialRecord | undefined =>
  record && CALL_RECORD_OBJECTS.has(record.object) ? record : undefined;

/** Whether a call's record and a CRM search hit are the same Salesforce record. */
export const isSameCallRecord = (record: DialRecord, hit: CrmSearchHit): boolean =>
  record.object === hit.object && record.salesforceId === hit.salesforceId;
